export default __webpack_public_path__ + "static/media/idan-erlichman.c7b5a4fe.png";